import React, { useState } from 'react';
import { SimplifiedSystem } from '../../../../services/patchmanager/patchManagerModel';
import PPCheckBox from '../../../../components/Form/PPCheckBox';
import LcInfiniteTable from '../../../../components/Data/LcInfiniteTable';
import LcNoData from '../../../../components/Generic/LcNoData';
import LcLoading from '../../../../components/Generic/LcLoading';
import IconValue from '../../../../components/Layout/Dashboard/IconValue';
import { PiMonitorLight, PiMonitorPlay } from 'react-icons/pi';
import { Badge } from '@material-ui/core';
import ScheduledWeekComponente from '../../../../components/Generic/ScheduledWeekComponente';

interface PatchAutomationCardProps {
    focused: boolean;
    systemWithApds: any[];
    systemWithoutApds: any[];
    loadingAutomation: boolean;
    isHome: boolean;
    isSecOpsPage: boolean;
}

const columnsPmAutomationSystems = [
    { field: "computerName", headerName: "Hostname", width: "15%", align: 'left', fontSize: '11px' },
    { field: "automated", headerName: "Automação", width: "5%", align: 'center', fontSize: '11px', renderCell: (row) => row.automated ? <p style={{ color: 'var(--status-green)' }}>Sim</p> : <p style={{ color: 'var(--emphasis)' }}>Não</p>, },
    { field: "operatingSystem", headerName: "Sistema", width: "15%", align: 'left', fontSize: '11px' },
    { field: "frequency", headerName: "Frequência", width: "10%", align: 'center', fontSize: '11px' },
    { field: "days", renderCell: (row) => ScheduledWeekComponente({ activeDays: row.days, weekOfMonth: row.weekOfMonth }), headerName: "Dia(s)", width: "20%", align: 'center', fontSize: '11px' },
    { field: "time", headerName: "Horário", width: "10%", align: 'center', fontSize: '11px' },
    {
        field: "reboot", headerName: "Reboot", width: "10%", align: 'center', fontSize: '11px',
        renderCell: (row) => row.reboot === true ? "Sim" : row.reboot === false ? "Não" : "-"
    }
];

const PatchAutomationCard: React.FC<PatchAutomationCardProps> = ({
    focused,
    systemWithApds,
    systemWithoutApds,
    loadingAutomation,
    isHome,
    isSecOpsPage,
}) => {
    const [withADP, setWithADP] = useState<boolean>(true);
    const [withoutADP, setWithoutADP] = useState<boolean>(true);

    const handleCheckboxChange = (name: string, value: boolean) => {
        if (name === 'withADP') setWithADP(value);
        if (name === 'withoutADP') setWithoutADP(value);
    };

    // Map data into the simplified system type
    const simplifiedSystemWithApds: SimplifiedSystem[] = systemWithApds
        ? systemWithApds.map(({ computerName, domain, operatingSystem = "", taskName = "" }: any) => {
            let schedule = { Days: [], Time: "", Reboot: false, Frequency: "", OS: "", WeekOfMonth: "0" };
            try {
                console.log(taskName)
                schedule = JSON.parse(taskName);
            } catch { }
            return {
                computerName,
                domain,
                automated: true,
                operatingSystem: schedule.OS || operatingSystem || "",
                days: schedule.Days || [],
                time: schedule.Frequency ? schedule.Time.split(':')[0] + ":" + schedule.Time.split(':')[1] || "-" : "-",
                reboot: schedule.Frequency ? typeof schedule.Reboot === "boolean" ? schedule.Reboot : false : undefined,
                frequency: schedule.Frequency || "-",
                weekOfMonth: schedule.WeekOfMonth
            };
        })
        : [];

    const simplifiedSystemWithoutApds: SimplifiedSystem[] = systemWithoutApds
        ? systemWithoutApds.map(({ computerName, domain, operatingSystem = "", WeekOfMonth = "0" }: any) => ({
            computerName,
            domain,
            automated: false,
            operatingSystem,
            days: [],
            time: "-",
            reboot: false,
            frequency: "-",
            weekOfMonth: WeekOfMonth
        }))
        : [];

    const combinedSystems: SimplifiedSystem[] = [
        ...(withoutADP ? simplifiedSystemWithoutApds : []),
        ...(withADP ? simplifiedSystemWithApds : []),
    ];

    if (focused) {
        return (
            <>
                <div className='implantation-focused'>
                    <PPCheckBox
                        checked={withADP}
                        name='withADP'
                        title={`Sistemas com automações ${simplifiedSystemWithApds.length}`}
                        onChange={(e: any) => handleCheckboxChange('withADP', e.target.value)}
                        className='row'
                    />
                    <PPCheckBox
                        checked={withoutADP}
                        name='withoutADP'
                        title={`Sistemas sem automações ${simplifiedSystemWithoutApds.length}`}
                        onChange={(e: any) => handleCheckboxChange('withoutADP', e.target.value)}
                        className='row'
                    />
                </div>
                {combinedSystems && combinedSystems.length > 0 ? (
                    <LcInfiniteTable
                        rows={combinedSystems}
                        columns={columnsPmAutomationSystems}
                        loadMore={() => undefined}
                        size={combinedSystems.length}
                        hidePagination
                        height='calc(100% - 55px)'
                    />
                ) : (
                    <LcNoData />
                )}
            </>
        );
    } else {
        return (
            <LcLoading loading={loadingAutomation}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <IconValue
                        icon={<PiMonitorPlay size={32} />}
                        value={systemWithApds ? systemWithApds.length : 0}
                        color="#3EBB3F"
                        description='Sistemas com automações'
                        cssClass='automation-icons'
                    />
                    <IconValue
                        icon={<PiMonitorLight size={32} />}
                        value={systemWithoutApds ? systemWithoutApds.length : 0}
                        color="#FFA400"
                        description='Sistemas sem automações'
                        cssClass='automation-icons'
                        backgroundColor='#000'
                    />
                </div>
            </LcLoading>
        );
    }
};

export default PatchAutomationCard;